import ProductPageContainer from "../../../components/applications/eCommerce/productPage";

const ProductPage = () => {
  return <ProductPageContainer />;
};

export default ProductPage;
